import { FC, useContext, useEffect, useState } from "react";
import { Box, Typography, Button, TextField } from "@mui/material";

import { LoadingWrapper } from "@components";
import { useProperty } from "@services";
import HotelIdIcon from "@assets/svg/hotelIdIcon.svg?react";
import { useTranslation } from "react-i18next";
import { ToastMessageContext } from "@context/toast-message-cotnext";
import { SuccessLinking } from "../../pages/PropertiesManagement/Linking/Components/SuccessLinking";

interface BookingHotelIdProps {
  onNext: () => void;
  onSUccessHotel: (hotelId: string) => void;
  property: any;
  onDone: () => void;
  propertyType?: 'collected' | 'separated';
}

const BookingHotelId: FC<BookingHotelIdProps> = ({
  onNext,
  onSUccessHotel,
  property,
  onDone,
  propertyType,
}) => {
  const [value, setValue] = useState<string>("");
  const { checkBookingConnectionQuery, connectAirbnbPropertyToBookingMutation } = useProperty();
  const { t } = useTranslation();
  const { showSuccess, showError } = useContext(ToastMessageContext);
  const [syncSuccess, setSynSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const propertyId = property?.propertyId;

  const { isError, isPending, mutate, data, reset } = checkBookingConnectionQuery({
    onSuccess: () => {},
    onError: () => {},
  });

  return (
    <LoadingWrapper loading={false}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: "70vh",
        }}
      >
        <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
          <Typography
            sx={{ fontWeight: 400, fontSize: "16px", color: "#0F172A" }}
          >
            {t("BOOKING.IDCODE")}
            <span style={{ color: "#5B3FFF", fontSize: "13px" }}>
              {" "}
              {property?.propertyName + " "}
            </span>
            {t("BOOKING.ON_BOOKING")}
          </Typography>
          <Typography
            sx={{
              color: "#8E98A1",
              mt: 0.5,
            }}
          >
            {t("BOOKING.ONLINKING")}
          </Typography>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "14px",
              lineHeight: "24px",
              mt: 6,
              mx: 1,
              mb: 0.5,
              color: "rgba(51, 24, 96, 1)",
            }}
          >
            {`${t("BOOKING.HOTEL_ID")} `}
            <Box
              component="span"
              sx={{
                color: "red",
              }}
            >
              *
            </Box>
          </Typography>
          <TextField
            sx={isError ? _inputError : _inputStyle}
            onChange={(e) => {
              setValue(e.target.value);
              reset();
            }}
            name="hotelId"
            value={value ?? ""}
            placeholder={t('BOOKING.ENTER_HOTEL_ID_PLACEHOLDER') || ''}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <HotelIdIcon
              style={{
                width: "487px",
                height: "175px",
              }}
            />
          </Box>
        </Box>
        <Box sx={{ alignItems: "center" }}>
          {/* Error Message Display */}
          {errorMessage && (
            <Typography
              sx={{
                color: '#EF4444',
                fontSize: '14px',
                fontFamily: 'Tajawal',
                marginBottom: 2,
                textAlign: 'right',
              }}
            >
              {errorMessage}
            </Typography>
          )}
          
          <Button
            size={"small"}
            variant={"contained"}
            onClick={() => {
              setErrorMessage("");
              // Both flows: save hotel ID and go to next step
              // API call will be handled in BookingSubmitStatus
              onSUccessHotel(value);
              onNext();
            }}
            disabled={!value?.length}
          >
            {t("BOOKING.NEXT")}
          </Button>
        </Box>
      </Box>
    </LoadingWrapper>
  );
};
export default BookingHotelId;
const _inputStyle = {
  border: " 1px solid rgba(234, 237, 241, 1)",
  borderRadius: "4px",
  width: "337px",
  height: "47px",
  px: 2,
  pb: -2,
  "& .MuiInput-underline:after": {
    borderBottomColor: "yellow",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "white",
    },
    "&:hover fieldset": {
      borderColor: "white",
    },
    "&.Mui-focused fieldset": {
      border: "0px",
    },
  },
};
const _inputError = {
  ..._inputStyle,
  border: " 1.5px solid rgba(215, 0, 21, 1)",
};
